export default __webpack_public_path__ + "static/media/gtvt.62812d62.jpg";